import { TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useContext, useEffect, useState } from 'react'

import { numberWithCommas } from '../../utils'
import { AppStateContext } from '../../contexts'
import SwapIcon from '../../assets/icons/swap-icon.svg'
import { textFieldWhiteBg } from '../../theme/custom-styles'
import { parseNumber } from '../customer-companies-management/utils'

export const ExchangeCalculatorForm = () => {
  const fromCurrencyQuantity = '1'
  const { USDDollarRate } = useContext(AppStateContext)
  const { t } = useTranslation(['banks-balances-management'])

  const [toCurrencySymbol, setToCurrencySymbol] = useState('COP')
  const [toCurrencyQuantity, setToCurrencyQuantity] = useState('0')
  const [fromCurrencySymbol, setFromCurrencySymbol] = useState('USD')
  const [toCurrencyQuantityResult, setToCurrencyQuantityResult] = useState('0')
  const [fromCurrencyQuantityResult, setFromCurrencyQuantityResult] = useState('0')

  useEffect(() => {
    if (USDDollarRate) {
      setToCurrencyQuantity(numberWithCommas(USDDollarRate))
    }
  }, [USDDollarRate])

  const handleChangeCurrenciesSides = () => {
    if (toCurrencySymbol === 'COP') {
      setToCurrencySymbol('USD')
      setFromCurrencySymbol('COP')
      setToCurrencyQuantity(numberWithCommas(USDDollarRate || 0))
    }

    if (toCurrencySymbol === 'USD') {
      setToCurrencySymbol('COP')
      setFromCurrencySymbol('USD')
      setToCurrencyQuantity(numberWithCommas((1 / (USDDollarRate || 1)).toFixed(5)))
    }

    setToCurrencyQuantityResult('0')
    setFromCurrencyQuantityResult('0')
  }

  const handleGetFromCurrencyValue = (valueToSet: string) => {
    const extractedNumberOfValueToSet = fromCurrencySymbol === 'COP' ? valueToSet.replaceAll(',', '').trim() : valueToSet.replaceAll(',', '').trim()
    console.log('extractedNumberOfValueToSet', extractedNumberOfValueToSet)

    if (isNaN(Number(extractedNumberOfValueToSet))) return ''

    if (extractedNumberOfValueToSet === '') return ''

    return parseNumber(extractedNumberOfValueToSet)
  }

  return (
    <div className="company-customer-funding-content-container">
      <div className="form-main-instruction">{t('calculateYourFundsModal.mainInstruction', { fromCurrencyQuantity, fromCurrencySymbol, toCurrencyQuantity, toCurrencySymbol })}</div>
      <div className="trade-module-container exchange-rate-calculation-container">
        <div className="operation-container operation-container-50">
          <div className="operation-title">{`${t('calculateYourFundsModal.fromCurrencyInstruction', { fromCurrencySymbol })}:`}</div>
          <div className="operation-calculation-container">
            <div
              style={{ width: '80%' }}
              className="operation-text-field-container"
            >
              <TextField
                fullWidth
                placeholder="$0"
                variant="standard"
                sx={textFieldWhiteBg}
                value={fromCurrencyQuantityResult || ''}
                onBlur={() => {
                  if (fromCurrencyQuantityResult.slice(-1) === '.') {
                    setFromCurrencyQuantityResult(fromCurrencyQuantityResult.slice(0, -1))
                  }

                  if (fromCurrencyQuantityResult === '') {
                    setToCurrencyQuantityResult('0')
                    setFromCurrencyQuantityResult('0')
                  }
                }}
                onChange={(event) => {
                  const fromCurrencyQuantityValueToSet = handleGetFromCurrencyValue(String(event.target.value))

                  if (fromCurrencyQuantityValueToSet === '') {
                    setToCurrencyQuantityResult('')
                    setFromCurrencyQuantityResult('')
                    return
                  }

                  if (fromCurrencySymbol === 'USD') {
                    setToCurrencyQuantityResult(numberWithCommas((Number(fromCurrencyQuantityValueToSet.replaceAll(',', '').trim()) * Number(USDDollarRate || 1)).toFixed(2)))
                  }

                  if (fromCurrencySymbol === 'COP') {
                    const valueCalculation = Number(fromCurrencyQuantityValueToSet.replaceAll(',', '').trim()) / Number(USDDollarRate || 1)
                    const valueToSet = valueCalculation < 0.1 ? valueCalculation.toFixed(6) : valueCalculation.toFixed(2)

                    setToCurrencyQuantityResult(numberWithCommas(valueToSet))
                  }

                  setFromCurrencyQuantityResult(fromCurrencyQuantityValueToSet)
                }}
              />
            </div>
            <div
              style={{ width: '20%' }}
              className="operation-currency-data-container"
            >
              {fromCurrencySymbol}
            </div>
          </div>
        </div>
        <div
          onClick={handleChangeCurrenciesSides}
          className="swap-transfer-icon-container"
        >
          <img
            src={SwapIcon}
            alt="swap-icon"
          />
        </div>
        <div className="operation-container operation-container-50">
          <div className="operation-title">{`${t('calculateYourFundsModal.toCurrencyInstruction', { toCurrencySymbol })}:`}</div>
          <div className="operation-calculation-container">
            <div
              style={{ width: '80%' }}
              className="operation-text-field-container"
            >
              <TextField
                disabled
                fullWidth
                placeholder="$0"
                variant="standard"
                sx={textFieldWhiteBg}
                value={toCurrencyQuantityResult || ''}
              />
            </div>
            <div
              style={{ width: '20%' }}
              className="operation-currency-data-container"
            >
              {toCurrencySymbol}
            </div>
          </div>
        </div>
      </div>
      <div>
        <div className="calculation-warning">{t('calculateYourFundsModal.warningTextLine')}</div>
        <div
          style={{ marginTop: '8px' }}
          className="calculation-warning"
        >
          {t('calculateYourFundsModal.warningText')}
        </div>
      </div>
    </div>
  )
}
